export default {"src":"/_next/static/media/EMPTY_TASK.a3897a01.svg","height":165,"width":194,"blurWidth":0,"blurHeight":0};